import instagram from "../Components/Assets/instagram_icon.png";
import youtube from "../Components/Assets/youtube_icon.png";
import facebook from "../Components/Assets/facebook_icon.png";
import "./CSS/Confirmation.css";
import { useEffect, useState } from "react";

const Confirmation = () => {
  const [digitalItems, setDigitalItems] = useState([]);
  const [orderStatus, setOrderStatus] = useState("processing");
  const [customerEmail, setCustomerEmail] = useState("");

  useEffect(() => {
    const processOrder = async () => {
      try {
        const purchasedItemsStr = localStorage.getItem("purchasedItems");
        console.log("Raw localStorage purchasedItems:", purchasedItemsStr);

        if (!purchasedItemsStr) {
          console.warn("No purchased items found in localStorage.");
          setOrderStatus("done");
          return;
        }

        const purchasedItems = JSON.parse(purchasedItemsStr);
        console.log("Parsed purchased items:", purchasedItems);

        purchasedItems.forEach((item, idx) => {
          console.log(
            `Item ${idx}: ${item.name} | fileType="${item.fileType}" | pdfUrl="${item.pdfUrl}"`,
          );
        });

        const params = new URLSearchParams(window.location.search);
        const squareOrderId =
          params.get("orderId") ||
          params.get("transactionId") ||
          `order-${Date.now()}`;
        console.log("Square order ID from URL:", squareOrderId);

        // ── Get customer email (3 sources) ──────────────────────────
        let email = "";

        // Source 1: Look up email from Square using the order ID
        if (squareOrderId && !squareOrderId.startsWith("order-")) {
          try {
            const emailRes = await fetch(
              `https://backend.mariemadeit.com/get-order-email/${squareOrderId}`,
            );
            const emailData = await emailRes.json();
            if (emailData.success && emailData.email) {
              email = emailData.email;
              console.log("✅ Got email from Square order:", email);
            }
          } catch (e) {
            console.warn("Could not fetch email from Square order");
          }
        }

        // Source 2: localStorage (logged in users)
        if (!email) {
          email = localStorage.getItem("customerEmail") || "";
          if (email) console.log("✅ Got email from localStorage:", email);
        }

        // Source 3: empty — order still processes, download button shows on page
        if (!email)
          console.warn(
            "⚠️ No email found — download button will still show on page",
          );

        setCustomerEmail(email);

        // ── Confirm order with backend ───────────────────────────────
        const confirmRes = await fetch(
          "https://backend.mariemadeit.com/confirm-order",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              cart: purchasedItems,
              customerEmail: email,
              squareOrderId,
            }),
          },
        );

        const confirmData = await confirmRes.json();
        console.log("Confirm order response:", confirmData);

        if (!confirmData.success) {
          console.error("Confirm order failed:", confirmData.error);
          setOrderStatus("error");
          return;
        }

        // ✅ Use tokens from backend — never expose real PDF URL
        if (
          confirmData.downloadTokens &&
          confirmData.downloadTokens.length > 0
        ) {
          setDigitalItems(confirmData.downloadTokens);
        }

        setOrderStatus("done");
        localStorage.removeItem("purchasedItems");
      } catch (error) {
        console.error("Error processing order:", error.message);
        setOrderStatus("error");
      }
    };

    processOrder();
  }, []);

  // ✅ Routes through secure backend token — real PDF URL never exposed
  const handleDownload = (token, itemName) => {
    window.open(`https://backend.mariemadeit.com/download/${token}`, "_blank");
  };

  return (
    <div className="confcontainer">
      <div className="confirmation-page">
        <h1>Thank You for Your Purchase!</h1>
        <h3>Your order is being processed. You will receive an email confirmation shortly. Once your payment is confirmed, PDF patterns will be sent to your email separately.<i> (If you have any trouble finding the email for PDF patterns, please check your spam folder.)</i></h3>

        {/*orderStatus === "processing" && (
          <p>Processing your order, please wait...</p>
        )} 

        {orderStatus === "error" && (
          <p style={{ color: "red" }}>
            There was an issue processing your order. Please contact us if you
            don't receive your items.
          </p>
        )}

        {orderStatus === "done" && (
          <>
            <p>Your receipt has been sent to your email for your records.</p>

            {digitalItems.length > 0 ? (
              <div className="digital-downloads">
                <h2>Your Digital Downloads</h2>
                <p>
                  A download link has also been sent to{" "}
                  <strong>{customerEmail || "your email"}</strong>.
                </p>
                <div className="downloads-list">
                  {digitalItems.map((item, index) => (
                    <div key={index} className="download-item">
                      <p className="download-name">{item.productName}</p>
                      <button
                        className="download-button"
                        onClick={() =>
                          handleDownload(item.token, item.productName)
                        }
                      >
                        Download PDF
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              <div className="no-digital-items">
                <p>No digital items in this order.</p>
              </div>
            )}
          </>
        )*/}

        <h2>
          Stay connected with us by following MarieMadeIt on social media for
          updates, new products, and Pattern tester calls.
        </h2>
        <a
          className="social"
          href="https://www.instagram.com/mariemadeit__/?hl=en"
          target="_blank"
          rel="noreferrer"
        >
          <img src={instagram} alt="instagram-logo" />
          Instagram
        </a>
        <a
          className="social"
          href="https://www.youtube.com/@MarieMadeIt96"
          target="_blank"
          rel="noreferrer"
        >
          <img src={youtube} alt="youtube-logo" />
          Youtube
        </a>
        <a
          className="social"
          href="https://www.facebook.com/profile.php?id=100077528543304"
          target="_blank"
          rel="noreferrer"
        >
          <img src={facebook} alt="facebook-logo" />
          Facebook
        </a>
        <p>Thank you once again for choosing MarieMadeIt!</p>
        <a className="returnbtn" href="/">
          Return Home
        </a>
      </div>
    </div>
  );
};

export default Confirmation;
